export const createProducerProspect = `
  mutation createProducerProspect($input: CreateProducerProspectInput!) {
    createProducerProspect(input: $input) {
      id
      createdAt
      updatedAt
    }
  }
`;

export const updateProducerProspect = `
  mutation updateProducerProspect($input: UpdateProducerProspectInput!) {
    updateProducerProspect(input: $input) {
      id
      updatedAt
    }
  }
`;

export const deleteProducerProspect = `
  mutation deleteProducerProspect($input: DeleteProducerProspectInput!) {
    deleteProducerProspect(input: $input) {
      id
    }
  }
`;

export const createProducerUser = /* GraphQL */ `
  mutation createProducerUser($input: CreateProducerUserInput!) {
    createProducerUser(input: $input) {
      userId
      email
      firstName
      id
      lastName
      middleName
      phoneNumber
      userRole
      channelType
      password
      reportingTo
      reportingToL2
      totalChannelLevels
      userLevel
    }
  }
`;

export const updateProducerUser = /* GraphQL */ `
  mutation updateProducerUser($input: UpdateProducerUserInput!) {
    updateProducerUser(input: $input) {
      userId
      email
      firstName
      id
      lastName
      middleName
      contactAddress {
        addrLine1
        addrLine2
        city
        state
        postCode
      }
      phoneNumber
      userRole
      password
      reportingTo
      reportingToL2
      totalChannelLevels
      userLevel
    }
  }
`;

export const deleteProducerUser = /* GraphQL */ `
  mutation deleteProducerUser($input: DeleteProducerUserInput!) {
    deleteProducerUser(input: $input) {
      userId
    }
  }
`;

export const bulkDeleteUser = /* GraphQL */ `
  mutation bulkDeleteUser($input: DeleteProducerUserBulkInput!) {
    deleteProducerUserBulk(input: $input) {
      returnedIds
    }
  }
`;

export const setPassword = /* GraphQL */ `
  mutation setPassword($username: String!, $password: String!) {
    setPassword(username: $username, password: $password)
  }
`;

export const createPaymentDetails = /* GraphQL */ `
  mutation createCustomerPayment($input: CreateCustomerPaymentInput!) {
    createCustomerPayment(input: $input) {
      cardDefault
      cardHolderName
      cardNumber
      expDate
      postalCode
      userId
      id
    }
  }
`;

export const updatePaymentDetails = /* GraphQL */ `
  mutation updateCustomerPayment($input: UpdateCustomerPaymentInput!) {
    updateCustomerPayment(input: $input) {
      cardDefault
      cardHolderName
      cardNumber
      expDate
      postalCode
      id
    }
  }
`;
export const createCustomerContact = ` 
mutation createCustomerContact($input: CreateCustomerContactAddressOccasionInput!) {
  createCustomerContactAddressOccasion(input: $input) {
    customerContact {
      id
    }
  }
}
`;

// export const createCustomerContact = /* GraphQL */ `
//   mutation createCustomerContact($input: CreateCustomerContactInput!) {
//     createCustomerContact(input: $input) {
//       userId
//       firstName
//       middleName
//       lastName
//       id
//     }
//   }
// `;
export const createCustomerOccasion = /* GraphQL */ `
  mutation createCustomerOccasion($input: CreateCustomerOccasionInput!) {
    createCustomerOccasion(input: $input) {
      id
    }
  }
`;
export const updateCustomerOccasion = /* GraphQL */ `
  mutation updateCustomerOccasion($input: UpdateCustomerOccasionInput!) {
    updateCustomerOccasion(input: $input) {
      id
    }
  }
`;
export const updateOccasionsReminder = /* GraphQL */ `
  mutation updateOccasionsReminder($input: UpdateOccasionsReminderInput!) {
    updateOccasionsReminder(input: $input) {
      customerContactId
    }
  }
`;

export const updateCustomerContact = /* GraphQL */ `
  mutation updateCustomerContact($input: UpdateCustomerContactInput!) {
    updateCustomerContact(input: $input) {
      id
      userId
      firstName
      middleName
      lastName
      email
      contactCategory
      contactCustomType
    }
  }
`;
/* eslint-disable */

export const deletePaymentDetails = /* GraphQL */ `
  mutation deleteCustomerPayment($input: DeleteCustomerPaymentInput!) {
    deleteCustomerPayment(input: $input) {
      id
    }
  }
`;

// export const createUser = /* GraphQL */ `
//   mutation createCustomerProfile($input: CreateCustomerProfileInput!) {
//     createCustomerProfile(input: $input) {
//       id
//       userId
//       firstName
//       lastName
//       middleName
//       phoneNumber
//       email
//     }
//   }
// `;

// export const updateUser = /* GraphQL */ `
//   mutation updateUser($input: UpdateCustomerProfileInput!) {
//     updateCustomerProfile(input: $input) {
//       userId
//     }
//   }
// `;

export const deleteContactDetails = /* GraphQL */ `
  mutation deleteCustomerContact($input: DeleteCustomerContactInput!) {
    deleteCustomerContact(input: $input) {
      id
    }
  }
`;
export const createCustomerAddress = /* GraphQL */ `
  mutation createCustomerAddress($input: CreateCustomerAddressInput!) {
    createCustomerAddress(input: $input) {
      id
      addressType
      firstName
      lastName
      middleName
      phoneNumber
      instructions
      addrLine1
      addrLine2
      city
      addrState
      postCode
      customerContactId
      markDefault
      country
      customType
    }
  }
`;

export const deleteCustomerOccasion = /* GraphQL */ `
  mutation deleteCustomerOccasion($input: DeleteCustomerOccasionInput!) {
    deleteCustomerOccasion(input: $input) {
      id
    }
  }
`;

export const deleteCustomerAddress = /* GraphQL */ `
  mutation deleteCustomerAddress($input: DeleteCustomerAddressInput!) {
    deleteCustomerAddress(input: $input) {
      id
    }
  }
`;

export const updateCustomerAddress = /* GraphQL */ `
  mutation updateCustomerAddress($input: UpdateCustomerAddressInput!) {
    updateCustomerAddress(input: $input) {
      id
      addressType
      firstName
      lastName
      middleName
      phoneNumber
      instructions
      addrLine1
      addrLine2
      city
      addrState
      postCode
      customerContactId
      markDefault
      country
      customType
    }
  }
`;

export const deletePhoto = /* GraphQL */ `
  mutation deleteProducerProspectPhoto($input: DeleteProducerProspectPhoto!) {
    deleteProducerProspectPhoto(input: $input){
     fileName
     status
     contentType
    }
  }
`;